import {
	createBrowserRouter,
	Navigate,
	Outlet,
	redirectDocument,
	RouteObject,
	RouterProvider, useSearchParams
} from "react-router-dom-7"
import { Loading, NavigateWithParams, Page404 } from "~/shared/ui"

import { Processes } from "../processes"
import { OldAppsRouter } from "./OldAppsRouter"
import { devMode } from "~/shared/config"

const appModules = import.meta.glob(
	[
		"../../apps/*/index.ts",
		"../../apps/*/index.tsx",
		"../../apps/*/index.js",
		"../../apps/*/index.jsx"
	],
	{ eager: true, import: "routes" }
) as Record<string, RouteObject[]>

const appRoutes: RouteObject[] = Object.entries(appModules).map(
	([modulePath, routes]) => {
		const appName = /^\.\.\/\.\.\/apps\/([^/]+)/.exec(modulePath)?.[1]

		if (!appName) throw new Error("Не удалось распарсить имя приложения")

		return {
			path: "/" + appName + "/*",
			children: [
				...routes,
				{
					path: "*",
					element: <Page404 />
				}
			]
		}
	}
)

const router = createBrowserRouter([
	{
		hydrateFallbackElement: <div className="flex items-center justify-center w-[100vw] h-[100vh]">
			<Loading loading delay={0.5} />
		</div>,
		element: <>
			<Processes />
			<Outlet />
		</>,
		children: [
			{
				index: true,
				element: <Navigate to="/main" />
			},
			{
				path: "/a/auditory",
				element: <Navigate replace to="/auditory" />
			},
			{
				path: "/a/eios/restore-password",
				Component: () => {
					const [sp] = useSearchParams()
					return <Navigate replace to={`/main/restore-password?code=${sp.get("code")}`} />
				}
			},
			{
				path: "/a/eios",
				element: <Navigate replace to="/main" />
			},
			{
				path: "/a/eios/employee-area/dekanat/faculty/import-plan",
				element: <NavigateWithParams replace to="/dekanat/faculty/import-plan" />
			},
			{
				path: "/a/eios/employee-area/dekanat/faculty/import-plan/convert-to-elective",
				element: <NavigateWithParams replace to="/dekanat/faculty/convert-to-elective" />
			},
			{
				path: "/a/eios/employee-area/dekanat/faculty/import-plan/import-hours",
				element: <NavigateWithParams replace to="/dekanat/faculty/import-plan-hours" />
			},
			{
				path: "/a/eios/employee-area/dekanat/faculty/sess-report",
				element: <NavigateWithParams replace to="/dekanat/faculty/sess-report" />
			},
			{
				path: "/a/eios/employee-area/dekanat/faculty/*",
				element: <NavigateWithParams replace to="/dekanat/faculty/*" />
			},
			{
				path: "/a/eios/employee-area/dekanat/*",
				element: <Navigate replace to="/dekanat" />
			},
			{
				path: "/a/eios/student-area/*",
				element: <Navigate replace to="/main/personal-area" />
			},
			{
				path: "/a/eios/*",
				element: <Navigate replace to="/main" />
			},
			{
				path: "/a/*",
				element: devMode ? null :
					<div className="flex items-center justify-center w-[100vw] h-[100vh]">
						<Loading loading delay={0.5} />
					</div>,
				loader() {
					return devMode ? null : redirectDocument(location.pathname)
				}
			},
			...appRoutes,
			{
				path: "*",
				element: <Page404 />
			}
		]
	}
])

export function HostAppRouter() {
	return (
		<>
			{devMode ? <OldAppsRouter /> : null}
			<RouterProvider router={router} />
		</>
	)
}